import moment from 'moment';
import i18n from '../i18n';

export const getStyle = (screenSize, styles, name) => {
  switch (screenSize) {
    case 'large':
      return styles.default[name];
    case 'medium':
      return {
        ...styles.default[name],
        ...(styles.medium && styles.medium[name]),
      };
    case 'small':
      return {
        ...styles.default[name],
        ...(styles.medium && styles.medium[name]),
        ...(styles.small && styles.small[name]),
      };
    default:
      return styles.default[name];
  }
};

export const getModalStyle = (screenSize, styles) => {
  switch (screenSize) {
    case 'large':
      return styles.default;
    case 'medium':
      return {
        content: {
          ...styles.default.content,
          ...(styles.medium && styles.medium.content),
        },
        overlay: {
          ...styles.default.overlay,
          ...(styles.medium && styles.medium.overlay),
        },
      };
    case 'small':
      return {
        content: {
          ...styles.default.content,
          ...(styles.small && styles.small.content),
        },
        overlay: {
          ...styles.default.overlay,
          ...(styles.small && styles.small.overlay),
        },
      };
    default:
      return styles.default;
  }
};

export const getUrlId = url => {
  const indexOfSlash = url.lastIndexOf('/');
  const lastSection = url.substring(indexOfSlash + 1);
  if (isNaN(lastSection) || !lastSection) {
    return undefined;
  }
  return Number(lastSection);
};

export const styleMerge = (paramObj1, paramObj2) => ({ ...paramObj1, ...paramObj2 });

export const storeInsertItem = (array, item) => {
  const newArray = array.slice();
  newArray.splice(0, 0, item);
  return newArray;
};

export const storeInsertItems = (array, itemArray) => {
  const newArray = array.slice();
  itemArray.forEach((item) => {
    newArray.splice(0, 0, item);
  });
  return newArray;
};

export const storeRemoveItem = (array, id) => {
  if (!id) {
    console.error('storeRemove didn\'t receive the id of the object to remove');
    return array;
  }
  const newArray = array.slice();
  const index = array.findIndex(x => x.id == id);
  newArray.splice(index, 1);
  return newArray;
};

export const storeRemoveItems = (array, idList) => {
  if (!idList) {
    console.error('storeRemove didn\'t receive the id of the object to remove');
    return array;
  }
  const newArray = array.slice();

  for (const id in idList) {
    const index = array.findIndex(x => x.id == id);
    newArray.splice(index, 1);
  }

  return newArray;
};

export const storeUpdateObjectInArray = (array, responseItem) =>
  array.map(item => {
    if (item.id !== responseItem.id) {
      return item;
    }
    return {
      ...item,
      ...responseItem,
    };
  });

export const storeUpdateObjectsInArray = (array, responseItems) => {
  const updatesMap = new Map(responseItems.map(item => [item.id, item]));

  return array.map(item =>
    updatesMap.has(item.id) ? { ...item, ...updatesMap.get(item.id) } : item
  );
};



export const mergeObjectList = (oldItems, responseItems) => {
  const ids = new Set(oldItems.map(d => d.id));
  return [...oldItems, ...responseItems.filter(d => !ids.has(d.id))];
};

export const dateCompareFunction = (a, b) => (moment(a).isBefore(b) ? 1 : -1);

export const getTreatmentTypeTranslationKey = treatmentType => {
  let translationKey;
  if (treatmentType === 'workshop_maintenance') {
    translationKey = 'treatmentTypeWorkshopMaintenance';
  } else if (treatmentType === 'maintenance') {
    translationKey = 'treatmentTypeMaintenance';
  } else if (treatmentType === 'treatment') {
    translationKey = 'treatmentTypeTreatment';
  } else if (treatmentType === 'repair') {
    translationKey = 'treatmentTypeRepair';
  } else if (treatmentType === 'wash') {
    translationKey = 'treatmentTypeWash';
  }
  return translationKey;
};

export const toIsoDateString = (input) => {
  let m;

  // If it's already a Moment instance:
  if (moment.isMoment(input)) {
    m = input;

  // If it's a native Date object:
  } else if (input instanceof Date) {
    m = moment(input);

  // If it's a string (e.g. "2023-03-07T14:30:00Z"):
  } else if (typeof input === "string") {
    // Use moment.utc(...) if you prefer to interpret the string in UTC:
    // m = moment.utc(input);
    m = moment(input);

  } else {
    throw new Error("Invalid date input");
  }

  // Optionally handle invalid moments (invalid date strings, etc.)
  if (!m.isValid()) {
    throw new Error("Could not parse date input");
  }

  // Return just the date portion in ISO format
  return m.format("YYYY-MM-DD");
}

export const formatDate = (dateString) => {
  if (dateString === null || dateString === '') return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('fi-FI');
};

export const formatDateTime = (dateTimeString) => {
  if (dateTimeString === null || dateTimeString === '') return '';
  return moment(dateTimeString).format('D.M.YYYY HH:mm');
};

export const toDbDateTime = (dateTime) => {
  return dateTime ? moment(dateTime).format('YYYY-MM-DD HH:mm:ss') : null;
};

export const formatKm = (km) => {
  let kmFormatted = Math.round(km);
  kmFormatted = kmFormatted.toLocaleString('fi-FI');
  kmFormatted = kmFormatted + ' km';
  return kmFormatted;
};

export const getCsrfToken = () => {
  const name = 'csrftoken=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
};

export const truncateString = (str, num) => {
  if (str.length > num) {
    return str.slice(0, num) + "...";
  } else {
    return str;
  }
};

export const formatPrice = (price) => {
  return price.toLocaleString('fi-FI').replace('.', ',') + ' €';
};

// Formats a maintenance task's billed hours + piece-count amount.
// Includes hours when > 0 and amount when > 0; both are joined with ', ';
// returns '' when neither has a sensible value. An hourly job commonly leaves
// amount at the default 1, which is just noise next to the hours, so amount is
// hidden when it's 1 and we already show sensible hours.
export const formatTaskHoursAndAmount = (task, hoursUnit, piecesUnit) => {
  if (!task) {
    return '';
  }
  const parts = [];
  const hours = Number(task.billed_hours);
  const amount = Number(task.amount);
  const hasHours = !Number.isNaN(hours) && hours > 0;
  const hasAmount = !Number.isNaN(amount) && amount > 0;
  if (hasHours) {
    parts.push(hours.toLocaleString('fi-FI') + ' ' + hoursUnit);
  }
  if (hasAmount && !(hasHours && amount === 1)) {
    parts.push(amount.toLocaleString('fi-FI') + ' ' + piecesUnit);
  }
  return parts.join(', ');
};

export const getCurrentCompany = (user, selectedOrganizationId, selectedWorkshopId, selectedChainId) => {
  let currentCompany = null;

  if (selectedChainId) {
    const chain = user.chains && user.chains.find((c) => selectedChainId == c.id);
    if (chain) {
      return {
        ...chain,
        use_vehicle_identifier: false,
        feature_tasks_and_messages: true,
        feature_tasks_and_messages_enabled: true,
        feature_vehicle_reports_enabled: false,
        feature_vehicle_reports_pdf_enabled: false,
        feature_purchase_reports_enabled: false,
        paid_subscription: true,
        is_trialing: false,
        is_trialing_oe: false,
      };
    }
  } else if (selectedWorkshopId) {
    currentCompany = user.workshops.find((ws) => selectedWorkshopId == ws.id);
  } else if (selectedOrganizationId) {
    // Hack for all organizations view
    if (selectedOrganizationId === 'all') {
      return {
        id: 'all',
        name: i18n.t('showAllCompanies', { ns: 'Header' }),
        use_vehicle_identifier: true,
        feature_tasks_and_messages: true,
        feature_vehicle_reports_enabled: false,
        feature_vehicle_reports_pdf_enabled: false,
        feature_tasks_and_messages_enabled: true,
        feature_purchase_reports_enabled: false,
        // THE ENTRY POINT FOLLOWS THE USER, NOT THE SELECTION (OVIO-40). This synthetic
        // company stands in for "all companies I may access", and a flag it does not name
        // reads as undefined -- so the fleet-location button hid itself in the one view that
        // is the DEFAULT for anyone without a valid saved selection, including every user on
        // first login. Answering for ANY enabled organisation is safe: this decides whether
        // a door is shown, never what is behind it. The map itself answers per organisation
        // and the server enforces the tenant boundary on every read.
        feature_fleet_location_enabled: Boolean(
          user.organizations
          && user.organizations.some((org) => org.feature_fleet_location_enabled)
        ),
      };
    } else {
      currentCompany = user.organizations.find((org) => selectedOrganizationId == org.id);
    }
  }

  return currentCompany;
}

export const dbDateTimeFormat = 'YYYY-MM-DD HH:mm';
export const dbDateFormat = 'YYYY-MM-DD';

export const finnishDatetimeFormat = 'dd.MM.yyyy HH:mm';
export const finnishDateFormat = 'dd.MM.yyyy';


export const SERVICE_WORKSHOP = 'workshop';
export const SERVICE_PERSONAL = 'my';
export const SERVICE_FLEET = 'fleet';
export const SERVICE_ADMIN = 'admin';
export const SERVICE_CHAIN = 'chain';

export const TYPE_CARE_SERVICE = 'care_service';
export const TYPE_ORGANIZATION_GARAGE = 'organization_garage';
export const TYPE_WORKSHOP_ALL = 'workshop_all';
export const TYPE_CHAIN_CARE_SERVICE = 'chain_care_service';

export const INVITATION_WORKSHOP = 'workshop'
export const INVITATION_ORGANIZATION = 'organization'
export const INVITATION_GARAGE = 'garage'
export const INVITATION_VEHICLE = 'vehicle'

export const FLEET_INVITATION_TYPES = [INVITATION_ORGANIZATION, INVITATION_GARAGE, INVITATION_VEHICLE]

export const BLEEDING_EDGE_USERS = [
  'i.petajajarvi@gmail.com',
  'jari.puranen@icloud.com',
  'jari@kasvupartneri.fi',
  'jari.puranen@ovio.fi',
  'jari.puranen@tavata.events',
  'marko.msc@gmail.com',
  'info@asnoy.fi',
  'marko.paananen@ovio.fi',
  'tommi.mantila@gmail.com',
  'ismo.petajajarvi@ovio.fi',
  'tommi@manbytes.fi',
  'cale82@gmail.com',
  'joonas.soilu@biltec.fi'
];

// Who may decide a pending approval request, by portal: a Lupapyyntö (workshop ->
// chain) is the chain's call, a Lupapyyntö asiakkaalle (workshop -> fleet customer)
// the customer's. The backend enforces the same rule; this only decides whether the
// approve/reject controls are offered at all.
export function canResolveApprovalMessage(message, service) {
  if (!message || message.approval_status !== 'pending') return false;
  // The backend knows the exact rule (org admin/manager, addressed ajoneuvovastaava,
  // chain admin/manager); the portal checks below are only a fallback for old payloads.
  if (typeof message.can_resolve === 'boolean') return message.can_resolve;
  if (message.message_type === 'approval_request') {
    return service !== SERVICE_WORKSHOP && service !== SERVICE_FLEET;
  }
  if (message.message_type === 'customer_approval') {
    return service === SERVICE_FLEET;
  }
  return false;
}

// Toimipiste and ajoneuvovastaava live on the vehicle's per-organization data.
export function getVehicleBusinessUnitName(vehicle) {
  return vehicle && vehicle.organization_data && vehicle.organization_data.business_unit_name
    ? vehicle.organization_data.business_unit_name : null;
}

export function getVehicleResponsibleUserName(vehicle) {
  return vehicle && vehicle.organization_data && vehicle.organization_data.responsible_user_name
    ? vehicle.organization_data.responsible_user_name : null;
}
